import { CountriesState } from '../../models/countries-state';

export const initialCountriesState: CountriesState = {
	countries: [],
	paymentMethods: [],
	myCountry: { name: '', code: '', currencyCode: '' },
	allPaymentMethods: [],
};
